import React from 'react'
import { connect } from 'react-redux'
import FlowView from 'components/core/FlowView'
import { ContentHeader } from 'components/basic'
import { TicketCreator } from 'projects/flow-gui-access/components/2.4'

class TicketCreate extends FlowView {
  constructor (props) {
    super(props, 'Create Ticket')
  }

  render () {
    return (
      <div className='content-wrapper'>
        <ContentHeader title='Tickets' />
        <hr />
        <div className='row'>
          <TicketCreator {...this.props} />
        </div>
      </div>
    )
  }
}
//eslint-disable-next-line
TicketCreate = connect(state => state.siteReducer)(TicketCreate)
export default TicketCreate



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/2.4/ticket/create.js